interface StepHeaderProps {
  title?: string
  description?: string
  children?: React.ReactNode
}

export const StepHeader = ({ title, description, children }: StepHeaderProps) => {
  return (
    <div className="space-y-4">
      <div>
        {title && <h4 className="font-medium text-lg">{title}</h4>}
        {description && (
          <p className="font-medium text-md text-muted-foreground">{description}</p>
        )}
      </div>
      {children}
    </div>
  )
}
